import { mdBlocks } from '../../../../lib/visitorsAgent'

/** Model text as paragraphs, bullets and bold, built from React text nodes only. */
export function Md({ text }: { text: string }) {
  const blocks = mdBlocks(text)
  const seg = (b: ReturnType<typeof mdBlocks>[number]) =>
    b.segs.map((s, i) => (s.bold ? <strong key={i} className="font-semibold text-paper">{s.text}</strong> : <span key={i}>{s.text}</span>))
  return (
    <div className="space-y-2 break-words text-[14px] leading-relaxed text-paper-dim">
      {blocks.map((b, i) => (b.kind === 'li'
        ? <p key={i} className="flex gap-2"><span aria-hidden="true">•</span><span>{seg(b)}</span></p>
        : <p key={i}>{seg(b)}</p>))}
    </div>
  )
}
